import { useMemo } from "react";
import { useLocation } from "react-router";

/**
 * Hook to extract and parse all query parameters from the current URL.
 * Returns a plain object with query parameter names as keys and their values as strings.
 *
 * @returns Object containing all URL query parameters as key-value pairs
 *
 * @example
 * // URL: /search?city=Boston&state=MA&utm_source=google
 * const params = useUrlQueryParams();
 * // params = { city: 'Boston', state: 'MA', utm_source: 'google' }
 *
 * @example
 * // Access specific parameters
 * const { city, state } = useUrlQueryParams();
 */
const useUrlQueryParams = (): Record<string, string> => {
    const { search } = useLocation();

    return useMemo(
        () => Object.fromEntries(new URLSearchParams(search)),
        [search]
    );
};


export default useUrlQueryParams;
